<template>
  <div class="flex items-center gap-3">
    <country-flag
      :country-code="transferRecipient?.country_code"
      class="w-10 h-10"
      :is-loading="isLoading"
    />
    <div data-sentry-unmask>
      <p
        :class="fontSizeClass"
        class="font-semibold"
      >
        {{ transferRecipient?.business_name }}
      </p>
      <p class="text-gray-600 text-sm">
        Country: {{ transferRecipient?.country_code }} / Currency: {{ transferRecipient?.currency_alpha_code }}
      </p>
    </div>
  </div>
</template>
<script setup>
import CountryFlag from '@/components/ui/CountryFlag.vue';
import { computed } from 'vue';

const props = defineProps({
  transferRecipient: {
    type: Object,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md'].includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const fontSizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-sm';
    case 'md':
    default:
      return 'text-base';
  }
});
</script>
